module.exports = __webpack_public_path__ + "static/media/HPT-USDT.188de340.svg";